module.exports = __webpack_public_path__ + "img/map.f90077d3.png";